"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStartOutcome = void 0;
var WorkflowStartOutcome;
(function (WorkflowStartOutcome) {
    WorkflowStartOutcome["Started"] = "started";
    WorkflowStartOutcome["AlreadyRunning"] = "already_running";
    WorkflowStartOutcome["Notified"] = "notified";
    WorkflowStartOutcome["Skipped"] = "skipped";
})(WorkflowStartOutcome || (exports.WorkflowStartOutcome = WorkflowStartOutcome = {}));
//# sourceMappingURL=workflow-start-outcome.js.map